export default __webpack_public_path__ + "static/media/logo-fp.70d14074.svg";